import React, {ReactNode} from 'react'
import {Field} from 'react-final-form'
import {floatParser, intParser} from '../../../helpers/coreUtil'
import FormGroup from './FormGroup'

export enum FieldType {
  text,
  number,
  password,
  multipleLines,
}

const FieldWithLabel = (
  {
    rows = 3,
    id,
    name,
    required,
    children,
    subLabel,
    isVertical,
    isParseFloat,
    placeholder,
    type,
    formClassName,
    labelClassName,
    autoComplete,
    note,
    maxLength,
    min,
    max,
    parse,
    inputMode
  }: {
    id?: string
    name: string
    required?: boolean
    children: ReactNode
    subLabel?: ReactNode
    isVertical?: boolean
    isParseFloat?: boolean
    placeholder?: string
    type: FieldType
    formClassName?: string
    labelClassName?: string
    autoComplete?: string
    rows?: number // for multipleLines
    note?: ReactNode
    maxLength?: number // for multipleLinesTextField
    min?: number
    max?: number
    parse?: () => any,
    inputMode?: string
  }) => {
  return <FormGroup
    htmlFor={id || name}
    required={required}
    className={labelClassName}
    formClassName={formClassName}
    label={children}
    subLabel={subLabel}
    isVertical={isVertical}>
    <Field
      component={type === FieldType.multipleLines ? 'textarea' : 'input'}
      type={type === FieldType.password ? 'password' : 'text'}
      placeholder={placeholder}
      name={name}
      id={id || name}
      autoComplete={autoComplete}
      parse={type === FieldType.number ? isParseFloat ? floatParser : intParser : undefined}
      required={required}
      rows={type === FieldType.multipleLines ? rows : undefined}
      maxLength={type !== FieldType.number ? maxLength : undefined}
      min={type === FieldType.number ? min : undefined}
      max={type === FieldType.number ? max : undefined}
      parse={parse}
      inputMode={inputMode || 'input'}
      className="form-control"
    />
    {note}
  </FormGroup>
}
FieldWithLabel.displayName = 'FieldWithLabel'
export default FieldWithLabel
